module.exports = __webpack_public_path__ + "assets/img/tree.17073dcd.png";